import { getDeviceName } from 'src/app/core/common';
import { FileActionEnum, MimeTypesEnum } from 'src/app/utils/enums';
import { environment } from 'src/environments/environment';
import { AccountService } from '../../auth/account.service';
import { BlobToPdfService } from '../../blob-to-pdf.service';
import { FileConvertorService } from '../file-convertor-service';
import { ConversionOptions } from '../models/conversion-options';
import { ConvertorParams } from '../models/convertor-params';
import { BaseConversion } from './base-conversion';

declare var platform;

export class PdfToKesConversion extends BaseConversion {
    protected file: File | null;
    protected url: string = environment.conversions.kesPdfUrl;
    protected type: MimeTypesEnum = MimeTypesEnum.KesNoType;

    constructor(readonly services: [FileConvertorService, AccountService, BlobToPdfService]) {
        super(...services);
    }

    prepareConversionParams(): ConvertorParams | null {
        if (this.file === null) {
            return null;
        }

        const formData = new FormData();
        formData.append('file', this.file, this.fileName);

        return {
            action: this.action,
            type: this.type,
            formData,
            url: this.url,
            params: this.params,
            fileName: this.fileName,
            readingItemIdx: this.readingItemIdx || undefined,
            paneIndex: (this.paneIndex !== null ? this.paneIndex : null),
            metadata: this.metadata
        };
    }

    async setOptions(options: ConversionOptions): Promise<void> {
        options = options || {};
        const { action, fileName } = options;
        this.action = action || FileActionEnum.ExportKes;
        this.file = await this.blobToPdfService.getCurrentPDF();
        this.fileName = fileName || '';
        this.paneIndex = (options.paneIndex !== null ? options.paneIndex as number : null);
        this.metadata = (options.metadata ? options.metadata : null);

        if (this.file && this.fileName === '') {
            this.fileName = this.file.name;
        }

        const userInfo = await this.accountService.getAccountInfo();

        if (userInfo) {
            this.params = {
                protectionEnabled: false,
                extraTestProtectionSpellCheckDisabled: true,
                extraTestProtectionWordPredictionDisabled: true,
                acquireColumnsNotTagged: true,
                mergeZones: false,
                acquireColumnsTagged: true,
                readTagsSequence: true,
                readLanguageTags: true,
                doQuickConversion: false,
                doColorConversion: true,
                DeviceId: userInfo.id.toUpperCase(),
                DeviceName: getDeviceName().toUpperCase(),
                DeviceOs: platform.os.toString()
            };
        }
    }
}
